import React from 'react';
import { Formik, Form, Field, FieldArray } from 'formik';
import { Grid, Box, Button, Divider } from '@mui/material';
import { useSelector } from 'react-redux';

const ProfileForm = () => {
	const { agentlogin } = useSelector((state) => state.user);
	const handleFormSubmit = (data) => {
		let formData = {
			userId:
				agentlogin &&
				agentlogin.result &&
				agentlogin.result.result &&
				agentlogin.result.result.id,
			userFirstName: data.userFirstName,
			userLastName: data.userLastName,
			userPhoneCode: '91',
			userPhone: data.userPhone,
			agencyName: data.agencyName,
		};
	};
	return (
		<Formik
			initialValues={{
				userFirstName:
					agentlogin &&
					agentlogin?.result &&
					agentlogin?.result?.result &&
					agentlogin?.result?.result?.name.trimStart().split(' ')[0],
				userLastName:
					agentlogin &&
					agentlogin?.result &&
					agentlogin?.result?.result &&
					agentlogin?.result?.result?.name?.trimStart().split(' ')[1],
				userPhoneCode: '91',
				userPhone:
					agentlogin &&
					agentlogin?.result &&
					agentlogin?.result?.result &&
					agentlogin?.result?.result?.phone,
				agencyName:
					agentlogin &&
					agentlogin?.result &&
					agentlogin?.result?.result &&
					agentlogin?.result?.result?.agencyName,
			}}
			onSubmit={handleFormSubmit}>
			{(formik) => {
				const { errors, setFieldValue } = formik;
				return (
					<Form>
						<Box style={{ padding: 10 }}>
							<Grid container style={{ marginTop: 5, padding: 10 }} spacing={4}>
								<Grid item xs={12} lg={6}>
									<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
										First Name*
									</span>
									<br></br>
									<Field
										name='userFirstName'
										type='text'
										placeHolder='Enter First Name'
										style={{
											padding: 10,
											width: '100%',
											borderRadius: 5,
											border: errors?.userFirstName
												? '2px solid red'
												: '1px solid',
											marginTop: 10,
										}}
										inputProps={{
											style: { padding: 12 },
										}}
									/>
									<br />
									{errors?.userFirstName ? (
										<span style={{ color: 'red', fontSize: 12 }}>
											{errors?.userFirstName}
										</span>
									) : null}
								</Grid>
								<Grid item xs={12} lg={6}>
									<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
										Last Name*
									</span>
									<br></br>
									<Field
										name='userLastName'
										type='text'
										placeHolder='Enter Last Name'
										style={{
											padding: 10,
											width: '100%',
											borderRadius: 5,
											border: errors?.userLastName
												? '2px solid red'
												: '1px solid',
											marginTop: 10,
										}}
										inputProps={{
											style: { padding: 12 },
										}}
									/>
									<br />
									{errors?.userLastName ? (
										<span style={{ color: 'red', fontSize: 12 }}>
											{errors?.userLastName}
										</span>
									) : null}
								</Grid>
								<Grid item xs={12} lg={6}>
									<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
										Mobile Number *
									</span>
									<br></br>
									<Field
										name='userPhone'
										type='text'
										placeHolder='Enter Mobile Number'
										style={{
											padding: 10,
											width: '100%',
											borderRadius: 5,
											border: errors?.userPhone ? '2px solid red' : '1px solid',
											marginTop: 10,
										}}
										inputProps={{
											style: { padding: 12 },
										}}
									/>
									<br />
									{errors?.userPhone ? (
										<span style={{ color: 'red', fontSize: 12 }}>
											{errors?.userPhone}
										</span>
									) : null}
								</Grid>
								<Grid item xs={12} lg={6}>
									<span style={{ color: 'rgba(88, 89, 91, 1)' }}>
										Agency Name
									</span>
									<br></br>
									<Field
										name='agencyName'
										type='text'
										placeHolder='Enter Agency Name'
										style={{
											padding: 10,
											width: '100%',
											borderRadius: 5,
											border: errors?.agencyName
												? '2px solid red'
												: '1px solid',
											marginTop: 10,
										}}
										inputProps={{
											style: { padding: 12 },
										}}
									/>
									<br />
									{errors?.agencyName ? (
										<span style={{ color: 'red', fontSize: 12 }}>
											{errors?.agencyName}
										</span>
									) : null}
								</Grid>
								<Grid item xs={12} lg={3}>
									<Button
										type='submit'
										style={{
											background: 'rgb(25, 118, 210)',
											color: 'white',
											marginTop: 30,
											// padding: 16,
											borderRadius: 5,
											width: '100%',
										}}>
										Update
									</Button>
								</Grid>
							</Grid>
						</Box>
					</Form>
				);
			}}
		</Formik>
	);
};

export default ProfileForm;
